import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { FinanceDimensionValueMembersDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { Dimension } from 'modules/finance/pages/DimensionDetailPage/DimensionDetail/useDimensionDetail'
import { FinanceSettingsOutletContextProps } from 'modules/finance/pages/settings/FinanceSettingsPage'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import DimensionValueMembers from './DimensionValueDetail/DimensionValueMembers'

const DimensionsValueDetailPage = () => {
  const { hasCustomDimensionsFeature, canManageCustomDimensions } = useOutletContext<
    FinanceSettingsOutletContextProps & { dimension: Dimension }
  >()

  const { company } = useCurrentSession()
  const { value_id } = useParams()

  const { data, error } = useQuery(FinanceDimensionValueMembersDocument, {
    variables: {
      companyId: company.id,
      dimensionValueId: Number(value_id),
    },
  })
  const dataLoading = !data && !error
  const members = data?.finance.customDimensionMemberships
  const hasValue = data?.finance.customDimensionValue

  const canSeeValue = !!hasValue && canManageCustomDimensions && hasCustomDimensionsFeature

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      authorized={canSeeValue}
      error={error}
      loading={dataLoading}
      showHeader={false}
    >
      <Box flexDirection="column" gap="s16" width="full">
        {members && <DimensionValueMembers members={members} />}
      </Box>
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default DimensionsValueDetailPage
